module.exports = __webpack_public_path__ + "media/creditcard/mastercard-a044057f.png";